import { toRaw } from 'vue'
import { normaliseJson } from '@/utils/normaliseJson'

function swapOriginalAndShadowObjects(data: any) {
    const originalObject = JSON.parse(data);
    const nestedToTop = originalObject.ShadowData;
    delete originalObject['ShadowData'];
    const topToNest = originalObject;
    nestedToTop.ShadowData = topToNest;
    return JSON.stringify(nestedToTop);
}

function removeShadowObjects(data: any) {
    data = data.split("ShadowData");
    let originalData = data[0];
    while (originalData[(originalData.length - 1)] != ",") {
        originalData = originalData.substring(0, originalData.length - 1);
    }
    originalData = originalData.substring(0, originalData.length - 1); // remove last comma
    data = originalData + "}";
    return data;
}

function createOriginalHTML(j: any, item: any) {
    var textDisplay = "";
    switch (typeof j[item]) {
        case "boolean":
            textDisplay = j[item] ? "Yes" : "No";
            break;
        case "number":
            if (item.endsWith('Id')) {
                const i = item.substring(0, item.length - 2) + "Text";
                textDisplay = j[i];
            } else if (item.toLowerCase().includes('year')) {
                let textDisplay = j[item];
            } else {
                textDisplay = j[item].formatMoney(0);
            }
            break;
        case "string":
            if (item == "MembershipId") {
                textDisplay = j[item]
            } else if (j[item] == "true" || j[item] == "false") {
                textDisplay = j[item] == "true" ? "Yes" : j[item] == "false" ? "No" : j[item];
            } else if (item.includes("Postcode")) {
                textDisplay = j[item].toUpperCase();
            } else if (item.endsWith('Id')) {
                const i = item.substring(0, item.length - 2) + "Text";
                textDisplay = j[i];
            } else {
                textDisplay = j[item].toCapitalise();
            }
            break;
        case "object":
            textDisplay = j[item] ? [...Object.values(j[item])].join(", ") : j[item];
            break;
        default:
            textDisplay = j[item];
            break;
    }
    var d = document.createElement('div');
    d.textContent += textDisplay === "" || textDisplay === null ? "Not provided on the original quote" : "Original value: " + textDisplay;
    d.classList.add("alert", "alert-info", "data-original-values");
    return d;
}

function createDOMForOriginalHTML(j: any, parentName: any = "") {
    if (parentName != 'ShadowData') {
        for (var item in j) {
            var n = document.querySelector("[name='" + (parentName ? parentName + "." : "") + item + "']");
            if (n != null && !item.includes('Filter')) {
                if (item.includes('Fake') && typeof j[item.slice(0, -4)] === 'object') {
                    if (n && n.closest("div.col-sm-12")) {
                        n.closest("div.col-sm-12")!.prepend(createOriginalHTML(j, item.slice(0, -4)));
                    }
                }
                if (parentName && (parentName.includes("CorrespondenceAddress") || parentName.includes("RiskAddress"))) {
                    const n = document.querySelectorAll("[name='" + (parentName ? parentName + "." : "") + item + "']");
                    for (var i = 0; i < n.length; i++) {
                        const closestDiv = n[i].closest("div.col-sm-12");
                        if (closestDiv) {
                            closestDiv.prepend(createOriginalHTML(j, item));
                        }
                    }
                } else if (!item.includes('Fake')) {
                    const closestDiv = n.closest("div.col-sm-12");
                    if (closestDiv) {
                        closestDiv.prepend(createOriginalHTML(j, item));
                    }
                }
            }
            if (n === null && typeof j[item] === 'object' && j[item] !== null) {
                const p = parentName ? parentName + "." + item : item;
                createDOMForOriginalHTML(j[item], p);
            }
        }
    }
}

// The MVC anti-forgery token, rendered as a hidden input by @Html.AntiForgeryToken().
// Sent as the X-CSRF-TOKEN-VERIFICATION header (the customersite's configured header name).
function antiForgeryHeader(): Record<string, string> {
    const token = (document.querySelector('input[name="__RequestVerificationToken"]') as HTMLInputElement | null)?.value
    const headers: Record<string, string> = { 'X-Requested-With': 'XMLHttpRequest' }
    if (token) headers['X-CSRF-TOKEN-VERIFICATION'] = token
    return headers
}

// Carries the HTTP status + parsed body (ModelState object, message string, or null) so callers can
// surface server-side validation / errors rather than a generic failure.
export class ApiError extends Error {
    status: number
    body: unknown
    constructor(status: number, body: unknown) {
        super(`Request failed: ${status}`)
        this.name = 'ApiError'
        this.status = status
        this.body = body
    }
}

async function postJson(url: string, payload: any): Promise<any> {
    const response = await fetch(url, {
        method: 'POST',
        headers: { ...antiForgeryHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
    })
    const text = await response.text()
    let body: unknown = null
    try { body = text.trim() ? JSON.parse(text.trim()) : null } catch { body = text }
    // Non-OK, or an OK response that isn't JSON (e.g. an HTML error page from a redirected 500) — both are failures.
    if (!response.ok || typeof body === 'string') {
        console.error(`${url} failed:`, response.status, body)
        const structured = body !== null && typeof body === 'object'
        throw new ApiError(response.ok ? 500 : response.status, structured ? body : null)
    }
    return body
}

export async function initQuoteProcess(productId: string | null, quoteId: string | null, quoteAction: string | null, testId: string | null = null): Promise<{ data: any; hideLoader: boolean }> {
    const url = `/retail-shops/getriskdata?id=${quoteId}&action=${quoteAction}&testid=${testId}`;
    try {
        let hideLoader = false;
        const response = await fetch(url);
        let data = await response.json();

        if (data.riskData !== null && data.riskData !== "") {
            if (quoteAction?.toLowerCase().includes('review')) {
                if (!data.riskData.includes("\"ShadowData\"")) {
                    data.riskData = data.riskData.slice(0, -1) + ",\"ShadowData\":" + data.riskData + "}";
                }
                if (data.riskData.includes("\"ShadowData\"")) {
                    data.riskData = swapOriginalAndShadowObjects(data.riskData);
                }
            } else {
                if (data.riskData.includes("\"ShadowData\"")) {
                    data.riskData = removeShadowObjects(data.riskData);
                }
            }
            if (data.riskData.includes("\"ShadowData\"") && quoteAction?.toLowerCase().includes("review")) {
                var j = JSON.parse(data.riskData)
                createDOMForOriginalHTML(j.ShadowData);
            }
        }

        if (data.productOutput) {
            hideLoader = true;
        }
        return { data, hideLoader };
    } catch (error) {
        console.error('Error fetching quote process data:', error);
        throw error;
    }
}

export async function SaveQuoteStage(
    _action: string,
    _productId: string,
    _quoteId: string,
    riskDataJson: any,
    _agentId: string
): Promise<{ savedQuote: boolean }> {
    const riskData = normaliseJson(toRaw(riskDataJson))
    await postJson('/retail-shops/savepartial', riskData)
    return { savedQuote: true }
}

export async function DoQuote(
    _action: string,
    _productId: string,
    _quoteId: string,
    riskDataJson: any,
    _agentId: string,
    _ownerId: string,
    page: number = 0,
    // First quote-display rates: rate on initial questions only (additional answers stripped).
    initialOnly: boolean = false
): Promise<{ doneQuote: any }> {
    const riskData = normaliseJson(toRaw(riskDataJson))
    // page: 1 = initial->display, 2 = additional->confirmed; 0 = neutral re-rate (skips additional validation).
    // Quote-display re-rates (page 0) carry no editable customer detail, so they don't update the customer.
    const shouldUpdateCustomer = page !== 0
    const doneQuote = await postJson(`/retail-shops/getquote?page=${page}&shouldUpdateCustomer=${shouldUpdateCustomer}&initialOnly=${initialOnly}`, riskData)
    return { doneQuote }
}

type UpdateQuoteOptions = {
    schemeId: string
    page: number
    showReviewLists: boolean
    addonQuoteRequest: boolean
    transactionType?: string | null
    cover: any
    selectOnly: boolean
    singleInsurer?: boolean
    isSchemeSelected?: boolean
    initialOnly?: boolean
}

// Strip the cover's HTML display fields before POST — the AntiXss middleware rejects HTML in the body, and
// the re-rate regenerates them anyway; only structural fields (ids/limits/excesses/subcovers) matter.
function stripCoverDisplayHtml(cover: any): any {
    if (!cover || typeof cover !== 'object') return cover
    const { CoverSummary, CoverDetail, ...rest } = cover
    if (Array.isArray(rest.Endorsements)) {
        rest.Endorsements = rest.Endorsements.map(({ Summary, Content, Wording, EndorsementOverrideText, ...e }: any) => e)
    }
    if (Array.isArray(rest.Subcovers)) {
        rest.Subcovers = rest.Subcovers.map(stripCoverDisplayHtml)
    }
    return rest
}

export async function UpdateQuote(
    _action: string,
    _productId: string,
    _quoteId: string,
    opts: UpdateQuoteOptions
): Promise<{ UpdateQuote: any }> {
    const cover = stripCoverDisplayHtml(normaliseJson(toRaw(opts.cover)))
    const UpdateQuote = await postJson(`/retail-shops/updatecover?initialOnly=${opts.initialOnly === true}`, cover)
    return { UpdateQuote }
}

export async function PostQuoteValidation(
    _param: string = "",
    _quoteId: any,
    _productId: any,
    _action: any,
    _agentId: any,
    _ownerId: any,
    riskDataJson: any,
): Promise<{ postQuote: any }> {
    riskDataJson.skipProposerChecks = true
    const riskData = normaliseJson(toRaw(riskDataJson))
    const postQuote = await postJson('/retail-shops/postquotereferralcheck', riskData)
    return { postQuote }
}

export async function CheckPromos(
    promoCode: string,
    productId: string,
): Promise<{ promoValid: any }> {
    const promoValid = await postJson(`/Promotion/isValidPromotion/${promoCode}/${productId}`, {})
    return { promoValid }
}

// BCIS (buildings sum-insured calculator) is a Household-only feature — not part of the Retail journey.
export async function BCISCalculator(_payload: Record<string, any>) {
    throw new Error('BCIS calculator is not supported for the Retail product.')
}

// Persist the monthly/annual choice so it survives a reload (e.g. returning from the payment page).
export async function SavePaymentPreference(isMonthly: boolean): Promise<void> {
    await postJson('/retail-shops/setpaymentpreference', isMonthly)
}

// Emails a copy of the quote via MailController (SendQuoteEmail workflow)
export async function EmailQuote(emailAddress: string): Promise<{ emailed: boolean }> {
    await postJson('/mail/emailquote', { InsuredEmailAddress: emailAddress })
    return { emailed: true }
}
